import React, { useState, useEffect } from 'react';

const AlertBox = ({show,title,message,onOK}) => {
    if(show){
        return(
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
        <div style={{ background: '#ffffff', padding: '24px', borderRadius: '8px', width: '90%', maxWidth: '300px', textAlign: 'center' }}>
            <p style={{ marginBottom: '16px', fontSize: '16px', fontWeight:'bold', borderBottom:'solid 1px #aaaaaa', color: '#000' }}>
                {title ?? "Alert"}
            </p>
            <p style={{ marginBottom: '16px', fontSize: '16px', color: '#000' }}>
                {message}
            </p>
            <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={onOK} style={{ flex: 1, padding: '12px', background: '#AE3041', color: '#ffffff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>OK</button>
            </div>
        </div>
    </div>
        );
    }else{
        return null;
    }
};
export default AlertBox;